module.exports = __webpack_public_path__ + "static/5-9cdc0818c240c8ee363cebbf8a02da95.jpg";